// FAKE DATA
export const books = [
  {
    id: 1,
    title: "Crack the Coding Interview",
    url: "https://m.media-amazon.com/images/I/61mIq2iJUXL._SL1360_.jpg",
    originalPrice: 49.95,
    salePrice: 14.95,
    rating: 4.5,
  },
  {
    id: 2,
    title: "Atomic Habits",
    url: "https://m.media-amazon.com/images/I/51CtZSFgaWL.jpg",
    originalPrice: 39,
    salePrice: null,
    rating: 5,
  },
  {
    id: 3,
    title: "Can't Hurt Me",
    url: "https://m.media-amazon.com/images/I/81MtKRJ1HLL._SL1500_.jpg",
    originalPrice: 29,
    salePrice: null,
    rating: 5,
  },
  {
    id: 4,
    title: "Deep Work",
    url: "https://calnewport.com/wp-content/uploads/2015/11/Newport_DeepWork_HC_web.jpg",
    originalPrice: 44,
    salePrice: 19,
    rating: 4.5,
  },
  {
    id: 5,
    title: "The 10X Rule",
    url: "https://images.cdn1.buscalibre.com/fit-in/360x360/45/98/4598de4c72a635d005f2ace6742019d0.jpg",
    originalPrice: 32,
    salePrice: null,
    rating: 5,
  },
  {
    id: 6,
    title: "Sell Or Be Sold",
    url: "https://m.media-amazon.com/images/I/41YMyY802WL.jpg",
    originalPrice: 70,
    salePrice: 12.5,
    rating: 5,
  },
  {
    id: 7,
    title: "Rich Dad Poor Dad",
    url: "https://m.media-amazon.com/images/I/81x0fNqLc-L._SL1500_.jpg",
    originalPrice: 11,
    salePrice: 10,
    rating: 4,
  },
  {
    id: 8,
    title: "Cashflow Quadrant",
    url: "https://m.media-amazon.com/images/I/61Gb3GF1cFL._SL1482_.jpg",
    originalPrice: 38,
    salePrice: 17.95,
    rating: 4.5,
  },
  {
    id: 9,
    title: "48 Laws of Power Summary",
    url: "https://m.media-amazon.com/images/I/619u+GnhP0L._SL1360_.jpg",
    originalPrice: 35,
    salePrice: 19.95,
    rating: 4.5,
  },
  {
    id: 10,
    title: "The 5 Second Rule",
    url: "https://m.media-amazon.com/images/I/51oeTwQmhYS.jpg",
    originalPrice: 40,
    salePrice: null,
    rating: 5,
  },
  {
    id: 11,
    title: "How to Win Friends & Influence People",
    url: "https://m.media-amazon.com/images/I/91Ap7mQGj9L._SL1500_.jpg",
    originalPrice: 30,
    salePrice: 20,
    rating: 5,
  },
  {
    id: 12,
    title: "Mastery",
    url: "https://m.media-amazon.com/images/I/71zTtMP8ijL._SL1500_.jpg",
    originalPrice: 30,
    salePrice: 12.95,
    rating: 4.5,
  },
];